import { Injectable, Injector } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, Command } from '../../../core/model/command';
import { Observable } from 'rxjs';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { BuildingDocumentFormComponent } from '../../component/building-document-form/building-document-form.component';
import { buildingCommand } from '../../command/building.command';

@Injectable()
export class LinkBuildingDocumentCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === buildingCommand.linkDocument && command.context;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean | void> {
    if (command instanceof Command) {
      return this._actionService.open(BuildingDocumentFormComponent, this._injector, null, command.context, true);
    }
  }
}
